import React from 'react';

import { Card } from '@change/ds-core-ui';

import type { NormalizedLegislativeBody } from '../../hooks/useDecisionMakerSection/types';

import { BodyContent } from './BodyContent';
import { ViewMore } from './ViewMore';

export const LegislativeBodyCard: React.FC<{
	legislativeBody: NormalizedLegislativeBody;
}> = ({ legislativeBody }) => {
	return (
		<Card className="bg-fill-inverse-strong p-6 shadow-md">
			<BodyContent
				legislativeBody={legislativeBody}
				viewMoreTrigger={
					<ViewMore legislativeBody={legislativeBody}>
						<BodyContent
							legislativeBody={{ ...legislativeBody, viewMoreCount: 0, displayedDMs: legislativeBody.allDMs }}
						/>
					</ViewMore>
				}
			/>
		</Card>
	);
};
